/** public 폴더 정적 자산 URL (PUBLIC_URL=/aichat 프리픽스 포함) */
export const publicAsset = (relativePath: string): string => {
  const path = relativePath.startsWith('/') ? relativePath : `/${relativePath}`;
  return `${process.env.PUBLIC_URL}${path}`;
};
